import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import PaymentGatewayDrawer from "components/drawer/PaymentgatewayDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

const PaymentGatewayTable = ({ paymentgatewaydata, hideDelete, hideEdit }) => {
    const { title, serviceId, handleModalOpen, handleUpdate, isSubmitting } =
        useToggleDrawer();

    return (
        <>
            <DeleteModal id={serviceId} title={title} />
            <MainDrawer>
                <PaymentGatewayDrawer id={serviceId} />
            </MainDrawer>

            <TableBody>
                {paymentgatewaydata.map((gateway, index) => {
                    const methods = gateway.payment_types;

                    return methods.map((method, i) => (
                        <TableRow key={`${gateway.gateway_id}-${method}`}>
                            {i === 0 && (
                                <TableCell
                                    rowSpan={methods.length}
                                    className="text-center text-xs align-middle"
                                >
                                    {index + 1}
                                </TableCell>
                            )}


                            {i === 0 && (
                                <TableCell
                                    rowSpan={methods.length}
                                    className="text-center text-xs align-middle"
                                >
                                    {gateway.gateway_name}
                                </TableCell>
                            )}

                            <TableCell className="text-center text-xs capitalize">
                                {method}
                            </TableCell>


                            <TableCell className="text-center text-xs">
                                {gateway.charges[method]}
                            </TableCell>

                            {i === 0 && (
                                <TableCell
                                    rowSpan={methods.length}
                                    className="align-middle"
                                >
                                    <div className="flex justify-center">
                                        <EditDeleteButton
                                            id={gateway.gateway_id}
                                            handleUpdate={handleUpdate}
                                            handleModalOpen={handleModalOpen}
                                            // hideDelete={hideDelete}
                                            hideEdit={hideEdit}
                                        />
                                    </div>
                                </TableCell>
                            )}

                        </TableRow>
                    ));
                })}
            </TableBody>

        </>
    );
};

export default PaymentGatewayTable;
